import { decode as base64_decode, encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import moment from "moment";
import config from "../config";
import Cookies from "js-cookie";

class TrackingDashboardStore {
  total = 0;
  loading = false;
  trackData = [];
  vehicalState = [];
  usageGraphData = [];
  totalvehstate = [];
  livetrack = [];
  totalvehiclestate = [];
  notificationData = [];

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      trackData: observable,
      loading: observable,
      notificationData: observable,
      loadData: action,
      getUsageGraph: action,
      getMaxSpeedGraph: action,
      getNotificationData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, status }) {
    this.loading = true;

    // var postData = {
    //   companyId: companyId,
    //   userCompany: 1,
    //   vehicleStatus: status,
    //   isadmin: -1,
    //   limit: 500,
    // };

    var params = {
      companyId: companyId,
      userCompany: 1,
      status: status,
      isadmin: -1,
      limit: 500,
    };
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("DetailTracking/getDetailtrackDataByCH", {
        params: params,
      });

    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=vehicletracking&a=getDetailTrackDashboard",
    //     "postData=" + base64Input
    //   );

    var liveTrackingData = response?.data?.data?.detailtrack;
    var totalCount = response?.data?.data?.TotalCount;
    if (liveTrackingData && Number(totalCount) > 0) {
      Object.keys(liveTrackingData).map((e, i) => {
        let r = liveTrackingData[i];
        let defaultImage = "car-icon-blue.png";

        //  var diff = new Date(r.currtime) - new Date(r.updatedate);
        const diff = moment(r.currtime).diff(r.updatedate, "minutes");
        var vehicleTypeNew = r.vehicleTypeNew?.split(" ").join("-");
        if (diff >= 90) {
          liveTrackingData[i].listImage = vehicleTypeNew + "-gray.png";
          liveTrackingData[i].rowBackground = "gray";
          liveTrackingData[i].currentStatus = "nodata";
          defaultImage = "default-gray.png";
        } else if (r.acc == 1 && r.speed == 0) {
          //idle)
          liveTrackingData[i].listImage = vehicleTypeNew + "-yellow.png";
          liveTrackingData[i].rowBackground = "yellow";
          liveTrackingData[i].currentStatus = "idle";
          defaultImage = "default-yellow.png";
        } else if (r.acc == 0) {
          liveTrackingData[i].listImage = vehicleTypeNew + "-red.png";
          liveTrackingData[i].rowBackground = "red";
          liveTrackingData[i].currentStatus = "stop";
          defaultImage = "default-red.png";
        } else if (r.acc == 1 && r.speed > 0) {
          liveTrackingData[i].listImage = vehicleTypeNew + "-green.png";
          liveTrackingData[i].rowBackground = "green";
          liveTrackingData[i].currentStatus = "running";
          defaultImage = "default-green.png";
        }
        liveTrackingData[i].mapImage = liveTrackingData[i].listImage;

        try {
          require("../assets/images/detailtracking/" +
            liveTrackingData[i].listImage);
        } catch (err) {
          liveTrackingData[i].listImage = defaultImage;
        }

        try {
          require("../assets/images/livetracking/" +
            liveTrackingData[i].mapImage);
        } catch (err) {
          liveTrackingData[i].mapImage = defaultImage;
        }
      });

      this.trackData = liveTrackingData;

      this.vehicalState = response?.data?.data?.totalvehstate;

      this.total = parseInt(Number(response?.data?.data?.TotalCount));
    }

    this.loading = false;
  }

  // async getLiveRouteData({ companyId, offset, limit, searchField }) {
  //   var postData = {
  //     companyId: companyId,
  //     offset: 0,
  //     limit: 50,
  //     searchField: searchField,
  //   };
  //   const base64Input = await base64_encode(JSON.stringify(postData));
  //   // var response = await postApi
  //   //   .getClient()
  //   //   .post(
  //   //     "index.php?c=vehicletracking&a=getLiveRouteData",
  //   //     "postData=" + base64Input
  //   //   );

  //   var response = await postApi
  //     .getClient("NodeCoreUrl")
  //     .get("Dashboard/getLiveRouteData", {
  //       params: postData,
  //     });
  //   var liveTrackingData = response.data?.data?.livetrack;

  //   Object.keys(liveTrackingData).map((e, i) => {
  //     let r = liveTrackingData[i];

  //     //  var diff = new Date(r.currtime) - new Date(r.updatedate);
  //     const diff = moment(r.currtime).diff(r.updatedate, "minutes");
  //     var vehicleTypeNew = r.vehicleTypeNew?.split(" ").join("-");
  //     if (diff >= 90) {
  //       liveTrackingData[i].listImage = vehicleTypeNew + "-gray.png";
  //       liveTrackingData[i].rowBackground = "gray";
  //       liveTrackingData[i].currentStatus = "nodata";
  //     } else if (r.acc == 1 && r.speed == 0) {
  //       //idle)
  //       liveTrackingData[i].listImage = vehicleTypeNew + "-yellow.png";
  //       liveTrackingData[i].rowBackground = "yellow";
  //       liveTrackingData[i].currentStatus = "idle";
  //     } else if (r.acc == 0) {
  //       liveTrackingData[i].listImage = vehicleTypeNew + "-red.png";
  //       liveTrackingData[i].rowBackground = "red";
  //       liveTrackingData[i].currentStatus = "stop";
  //     } else if (r.acc == 1 && r.speed > 0) {
  //       liveTrackingData[i].listImage = vehicleTypeNew + "-green.png";
  //       liveTrackingData[i].rowBackground = "green";
  //       liveTrackingData[i].currentStatus = "running";
  //     }
  //     liveTrackingData[i].mapImage = liveTrackingData[i].listImage;

  //     try {
  //       require("../assets/images/detailtracking/" +
  //         liveTrackingData[i].listImage);
  //     } catch (err) {
  //       liveTrackingData[i].listImage = "car-icon-blue.png";
  //     }

  //     try {
  //       require("../assets/images/livetracking/" +
  //         liveTrackingData[i].mapImage);
  //     } catch (err) {
  //       liveTrackingData[i].mapImage = "car-icon-blue.png";
  //     }
  //   });

  //   this.livetrack = liveTrackingData;

  //   this.totalvehiclestate = response.data?.data?.totalvehstate;
  // }
  getLiveRouteData({ companyId, offset, limit, searchField }) {
  (async () => {
    try {
      const postData = {
        companyId,
        offset: 0,
        limit: 50,
        searchField,
      };

      const base64Input = await base64_encode(JSON.stringify(postData));

      const response = await postApi
        .getClient("NodeCoreUrl")
        .get("Dashboard/getLiveRouteData", {
          params: postData,
        });

      let liveTrackingData = response.data?.data?.livetrack;

      Object.keys(liveTrackingData).map((e, i) => {
        let r = liveTrackingData[i];

        const diff = moment(r.currtime).diff(r.updatedate, "minutes");
        let vehicleTypeNew = r.vehicleTypeNew?.split(" ").join("-");

        if (diff >= 90) {
          liveTrackingData[i].listImage = vehicleTypeNew + "-gray.png";
          liveTrackingData[i].rowBackground = "gray";
          liveTrackingData[i].currentStatus = "nodata";
        } else if (r.acc == 1 && r.speed == 0) {
          liveTrackingData[i].listImage = vehicleTypeNew + "-yellow.png";
          liveTrackingData[i].rowBackground = "yellow";
          liveTrackingData[i].currentStatus = "idle";
        } else if (r.acc == 0) {
          liveTrackingData[i].listImage = vehicleTypeNew + "-red.png";
          liveTrackingData[i].rowBackground = "red";
          liveTrackingData[i].currentStatus = "stop";
        } else if (r.acc == 1 && r.speed > 0) {
          liveTrackingData[i].listImage = vehicleTypeNew + "-green.png";
          liveTrackingData[i].rowBackground = "green";
          liveTrackingData[i].currentStatus = "running";
        }

        liveTrackingData[i].mapImage = liveTrackingData[i].listImage;

        try {
          require("../assets/images/detailtracking/" + liveTrackingData[i].listImage);
        } catch (err) {
          liveTrackingData[i].listImage = "car-icon-blue.png";
        }

        try {
          require("../assets/images/livetracking/" + liveTrackingData[i].mapImage);
        } catch (err) {
          liveTrackingData[i].mapImage = "car-icon-blue.png";
        }
      });

      this.livetrack = liveTrackingData;
      this.totalvehiclestate = response.data?.data?.totalvehstate;

    } catch (err) {
      console.error("Live route error:", err);
    }
  })();
}

  // async getUsageGraph({ companyId }) {
  //   var postData = { companyId: companyId };
  //   var base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post(
  //       "index.php?c=vehicle&a=usageGraphDashboard",
  //       "postData=" + base64Input
  //     );

  //   var data = response?.data?.data?.usagedata;
  //   if (data && data) {
  //     data.forEach((element, index) => {
  //       element.TotalTravelDistance = parseFloat(element.TotalTravelDistance);
  //     });
  //   }

  //   this.usageGraphData = data;

  //   return response?.data?.data?.usagedata;
  // }

  // async getUsageGraph({ companyId }) {
  //   var postData = {
  //     companyId: companyId,
  //     userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
  //     isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
  //     dashboardUsageGraph: 1,
  //   };

  //   if (config.pythonReport === 1) {
  //     // postData.companyId=10166
  //     var response = await postApi
  //       .getClient("report")
  //       .post("/graph/usageGraph", postData);
  //   } else {
  //     var base64Input = await base64_encode(JSON.stringify(postData));
  //     response = await postApi
  //       .getClient()
  //       .post(
  //         "index.php?c=vehicle&a=usageGraphDashboard",
  //         "postData=" + base64Input
  //       );
  //   }
  //   // console.log(response?.data?.data?.usagedata, "vehicle");

  //   var data = response?.data?.data?.usagedata;
  //   if (data && data) {
  //     data.forEach((element, index) => {
  //       element.TotalTravelDistance = parseFloat(element.TotalTravelDistance);
  //     });
  //   }
  //   // console.log(data);
  //   this.usageGraphData = data;
  //   // console.log(response?.data?.data?.usagedata);
  //   return response?.data?.data?.usagedata;

  //   // var postData = { companyId: companyId };
  //   // var response = await postApi.getClient("NodeCoreUrl").get("Dashboard/usageGraphDashboard", {params: postData});
  //   // var data = response?.data?.data?.usagedata;
  //   // if (data && data) {
  //   //   data.forEach((element, index) => {
  //   //     element.TotalTravelDistance = parseFloat(element.TotalTravelDistance);
  //   //   });
  //   // }
  //   // this.usageGraphData = data;
  //   // return response?.data?.data?.usagedata;
  // }
  
  async getUsageGraph({ companyId,currentDate }) {
  try {
    const userData = JSON.parse(base64_decode(Cookies.get("data")));

    const postData = {
      companyId,
      userId: userData.userId,
      isadmin: userData.isadmin,
      dashboardUsageGraph: 1,
      fromDate:currentDate,
      toDate:currentDate,
      offset: 0,
      limit: 10,
      isGraph:true,
    };

    let response;
    if (config.pythonReport === 1) {
      response = await postApi.getClient("report").post("fleet_report/fleetDaySummary", postData);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi
        .getClient()
        .post("index.php?c=vehicle&a=usageGraphDashboard", "postData=" + base64Input);
    }

    const usage = response?.data?.data?.daysummary;

    if (!Array.isArray(usage)) {
      console.error("UsageGraph data missing:", usage);
      return [];
    }

    usage.forEach((item) => {
      item.TotalTravelDistance = parseFloat(item.TotalTravelDistance || 0);
    });

    this.usageGraphData = usage;
    return usage;
  } catch (err) {
    console.error("getUsageGraph Error:", err);
    return [];
  }
}


 async getNotificationData(companyId) {
  try {
    const postData = { companyId };
    const base64Input = await base64_encode(JSON.stringify(postData));

    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("Dashboard/getNotificationData", {
        params: { companyId },
      });

    this.notificationData = response.data.data;
  } catch (err) {
    console.error("Notification error:", err);
  }
}

  // async getMaxSpeedGraph({ companyId, maxspeed }) {
  //   var postData = { companyId: companyId, type: maxspeed };
  //   var base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post(
  //       "index.php?c=vehicle&a=maxSpeedGraphDashboard",
  //       "postData=" + base64Input
  //     );

  //   var maxSpeedGraphData = response?.data?.data?.MaxSpeedGraph;
  //   if (maxSpeedGraphData && maxSpeedGraphData) {
  //     maxSpeedGraphData.forEach((element) => {
  //       // Convert specific properties to floats
  //       element.maxSpeed = parseFloat(element.maxSpeed);
  //     });
  //   }
  //   this.maxSpeedGraph = response?.data?.data?.MaxSpeedGraph;
  //   return response?.data?.data?.MaxSpeedGraph;
  // }

  // async getDistanceGraph({ companyId, distance }) {
  //   var postData = { companyId: companyId, type: distance };
  //   var base64Input = await base64_encode(JSON.stringify(postData));
  //   var response = await postApi
  //     .getClient()
  //     .post(
  //       "index.php?c=vehicle&a=maxSpeedGraphDashboard",
  //       "postData=" + base64Input
  //     );
  //   var distanceGraphData = response?.data?.data?.distancegraph;
  //   if (distanceGraphData && distanceGraphData) {
  //     distanceGraphData.forEach((element) => {
  //       // Convert specific properties to floats
  //       element.distanceTravel = parseFloat(element.distanceTravel);
  //     });
  //   }
  //   // this.distaceGraph = response?.data?.data?.distancegraph;
  //   this.distaceGraph = distanceGraphData;
  //   return response?.data?.data?.distancegraph;
  // }

  async getMaxSpeedGraph({ companyId, maxspeed,currentDate }) {
  try {
    const userData = JSON.parse(base64_decode(Cookies.get("data")));

    const postData = {
      companyId: companyId,
      type: maxspeed,
      userId: userData.userId,
      isadmin: userData.isadmin,
      dashboardMAxSpeedGraph: 1,
      fromDate:currentDate,
      toDate:currentDate,
      offset: 0,
      limit: 50,

    };

    let response;

    if (config.pythonReport === 1) {
      response = await postApi
        .getClient("report")
        .post("graph/maxspeedGraph", postData);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi
        .getClient()
        .post(
          "index.php?c=vehicle&a=maxSpeedGraphDashboard",
          "postData=" + base64Input
        );
    }

    const maxSpeedGraphData = response?.data?.data?.MaxSpeedGraph || [];

    maxSpeedGraphData.forEach((element) => {
      element.maxSpeed = parseFloat(element.maxSpeed || 0);
    });

    this.maxSpeedGraph = maxSpeedGraphData;

    return maxSpeedGraphData;
  } catch (error) {
    console.error("MaxSpeed Graph Error:", error);
    return [];
  }
}


async getDistanceGraph({ companyId, distance,currentDate,isGraph }) {
  try {
    console.log("📌 getDistanceGraph() called with:", companyId, distance);

    const postData = {
      companyId,
      type: distance,
      dashboardDistanceGraph: 1,
      userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
      isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
      fromDate: currentDate,
      toDate: currentDate,
      offset: 0,
      limit: 50,
      isGraph:true,
    };

    console.log("➡️ Sending postData:", postData);

    let response;

    if (config.pythonReport === 1) {
      console.log("🔗 Calling Python API: /graph/distanceGraph");

      response = await postApi
        .getClient("report")
        .post("tracking_report/distancereport", postData);

        console.log(response,"response")

    } else {
      console.log("🔗 Calling PHP API: distanceGraphDashboard");

      const base64Input = await base64_encode(JSON.stringify(postData));

      response = await postApi
        .getClient()
        .post(
          "index.php?c=vehicle&a=distanceGraphDashboard",
          "postData=" + base64Input
        );
    }

    console.log("📥 API Response:", response?.data);

    const distanceGraphData =
      response?.data?.data?.distanceReport ||
      response?.data?.data?.distanceReport ||
      [];
    

    console.log("📊 Parsed DistanceGraph:", distanceGraphData);

    distanceGraphData.forEach((row) => {
      row.distanceTravel = parseFloat(row.distanceTravel || 0);
    });

    this.distaceGraph = distanceGraphData;

    console.log("✅ Final Distance Graph:", distanceGraphData);

    return distanceGraphData;
  } catch (error) {
    console.error("❌ ERROR in getDistanceGraph():", error);

    this.distaceGraph = [];
    return [];
  }
}


}

export default TrackingDashboardStore;
